import React from "react";
import "./ProjectCard.css";
function ProjectCard({ imgSrc, title, body }) {
  return (
    <div className="projectCard">
      <img src={imgSrc} />
      <h2>{title}</h2>
      <p>{body}</p>
    </div>
  );
}

export default ProjectCard;
